<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <div>Welcome to Your Vue.js App</div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
}
</script>
